import React from 'react';
import { useIntl } from 'react-intl';
import { useT } from '@transifex/react';
import { RaisinContainer } from '@raisin/components-lib';
import getPageContent from 'utils/getPageContent';
import { FeaturedArticles, Tabs } from './components';
import * as S from './styles';
import { PressPageContentProps } from './types';

export const PressPageContent: React.FC<PressPageContentProps> = ({
  headingData,
  sidebarData,
  contentData,
  pressReleases,
  mediaArticles,
}) => {
  const intl = useIntl();
  const t = useT();

  return (
    <>
      {headingData.map((heading) => getPageContent(heading, t, undefined))}
      <RaisinContainer>
        <S.Grid>
          <S.Content>
            <FeaturedArticles featuredArticlesData={contentData} />
            <Tabs pressReleases={pressReleases} mediaArticles={mediaArticles} intl={intl} />
          </S.Content>
          <S.Sidebar>
            {sidebarData.map((sidebar) => getPageContent(sidebar, t, undefined))}
          </S.Sidebar>
        </S.Grid>
      </RaisinContainer>
    </>
  );
};
